var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',_vm._b({attrs:{"clearable":true,"size":"small"},on:{"input":_vm.handleChange},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}},'el-input',_vm.attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }